var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.766,
    height: 15,
    viewBox: "0 0 19.766 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_13352081061536572528",
    "data-name": 13352081061536573000,
    d: "M7.275,15a1.146,1.146,0,0,1-.811-.336L.336,8.537A1.147,1.147,0,0,1,1.958,6.916l5.27,5.269L17.764.383A1.147,1.147,0,0,1,19.475,1.91L8.13,14.617A1.147,1.147,0,0,1,7.307,15Z",
    transform: "translate(0 0)",
    fill: "#06c692"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickGreen);
export default __webpack_public_path__ + "static/media/tick-green.b01db653d28ca6c03db027cb8c88498d.svg";
export { ForwardRef as ReactComponent };